export { default as kennekLogo } from './kennekLogo.svg';
export { default as kennekLogoGreen } from './kennekLogoGreen.svg';
export { default as kennekFavicon } from './kennekFavicon.ico';
export { default as uploadIcon } from './uploadIcon.svg';
export { default as errorIcon } from './errorIcon.svg';
export { default as circledPound } from './circledPound.svg';
